<template>
	<div class="mainpage">
		<a-layout id="components-layout-demo-side" style="min-height: 100vh">
			<menuBar :current="current" :openKeys="openKeys"></menuBar>
			<a-layout style="overflow: auto;">
				<topBar :fatherMethod="initialize"></topBar>
				<a-layout-content v-if="!isfinish" style="text-align: center;margin-top: 20%;">
					<a-spin tip="Loading..." size="large" />
				</a-layout-content>
				<a-layout-content style="margin: 16px; min-width: 1192px;" v-if="isfinish">
					<div style="font-size: 20px;line-height: 30px;margin-bottom: 10px;font-weight: 700;padding-left: 8px;">首页</div>
					<div>
						<a-row type="flex" justify="space-around" :gutter="16">
							<a-col :span="6" class="datalist">
								<div>
									<span class="title">总销售额</span>
									<a style="float: right;" @click="gotopage('saleslist')">详情</a>
									<div style="margin-bottom: 20px;">
										<span style="font-size: 30px;">￥{{tradeAll.totalPrice/100}}</span>
									</div>
									<a-rate :defaultValue='5' disabled />
									<a-divider style="margin: 0;" />
									<div style="margin-top: 6px;font-size: 14px;color: #666;">
										<span>今日销售额 ¥ {{tradeAll.totalPriceNow/100}}</span>
									</div>
								</div>
							</a-col>
							<a-col :span="6" class="datalist">
								<div>
									<span class="title">总访问量</span>
									<a style="float: right;">详情</a>
									<div style="margin-bottom: 20px;">
										<span style="font-size: 30px;">8,846(拟)</span>
									</div>
									<a-rate :defaultValue='5' disabled />
									<a-divider style="margin: 0;" />
									<div style="margin-top: 6px;font-size: 14px;color: #666;">
										<span>今日访问量 ¥ 1,423(拟)</span>
									</div>
								</div>
							</a-col>
							<a-col :span="6" class="datalist">
								<div>
									<span class="title">订单笔数</span>
									<a style="float: right;" @click="gotopage('transactionlist')">详情</a>
									<div style="margin-bottom: 20px;">
										<span style="font-size: 30px;">{{tradeAll.sum}}</span>
									</div>
									<a-rate :defaultValue='5' disabled />
									<a-divider style="margin: 0;" />
									<div style="margin-top: 6px;font-size: 14px;color: #666;">
										<span>转化率 {{Math.ceil((tradeAll.sumNow/tradeAll.sum)*10*10)}}%</span>
									</div>
								</div>
							</a-col>
							<a-col :span="6" class="datalist">
								<div>
									<span class="title">服务费</span>
									<a style="float: right;" @click="gotopage('servicelist')">详情</a>
									<div style="margin-bottom: 20px;">
										<span style="font-size: 30px;">￥{{tradeAll.sumServiceFee/100000}}</span>
									</div>
									<a-progress :percent="78" size="small" status="active" :showInfo="false" strokeLinecap="square" strokeColor="#13c2c2" />
									<a-divider style="margin: 0;" />
									<div style="margin-top: 6px;font-size: 14px;color: #666;">
										<span>今日服务费 ￥ {{tradeAll.sumServiceFeeNow/100000}}</span>
									</div>
								</div>
							</a-col>
						</a-row>
					</div>
					<div style="font-size: 20px;line-height: 30px;margin-bottom: 10px;color: #666;padding-left: 8px;margin-top: 10px;">订单管理</div>
					<a-row>
						<a-col :span="4" class="orderlist" @click="gototransactionlist('all')">
							<div style="margin-top: 25px;"><span style="font-size: 30px;" class="hovernum">{{tradeInfo.sum}}</span></div>
							<div><span style="font-size: 18px;font-weight: 700;" class="hovertitle">全部</span></div>
						</a-col>
						<a-col :span="4" class="orderlist" @click="gototransactionlist('to_be_paid')">
							<div style="margin-top: 25px;"><span style="font-size: 30px;" class="hovernum">{{tradeInfo.to_be_paid}}</span></div>
							<div><span style="font-size: 18px;font-weight: 700;" class="hovertitle">待付款</span></div>
						</a-col>
						<a-col :span="4" class="orderlist" @click="gototransactionlist('have_paid')">
							<div style="margin-top: 25px;"><span style="font-size: 30px;" class="hovernum">{{tradeInfo.have_paid}}</span></div>
							<div><span style="font-size: 18px;font-weight: 700;" class="hovertitle">待发货</span></div>
						</a-col>
						<a-col :span="4" class="orderlist" @click="gototransactionlist('delivery')">
							<div style="margin-top: 25px;"><span style="font-size: 30px;" class="hovernum">{{tradeInfo.delivery}}</span></div>
							<div><span style="font-size: 18px;font-weight: 700;" class="hovertitle">已发货</span></div>
						</a-col>
						<a-col :span="4" class="orderlist" @click="gototransactionlist('finished')">
							<div style="margin-top: 25px;"><span style="font-size: 30px;" class="hovernum">{{tradeInfo.finished}}</span></div>
							<div><span style="font-size: 18px;font-weight: 700;" class="hovertitle">已完成</span></div>
						</a-col>
						<a-col :span="4" class="orderlist" @click="gototransactionlist('refund')">
							<div style="margin-top: 25px;"><span style="font-size: 30px;" class="hovernum">{{tradeInfo.refund}}</span></div>
							<div><span style="font-size: 18px;font-weight: 700;" class="hovertitle">申请退款售后</span></div>
						</a-col>
					</a-row>

					<div style="margin-top: 10px;background-color: white;">
						<a-tabs size="large">
							<a-tab-pane tab="销售额" key="1">
								<div style="margin-top: 30px;overflow: hidden;" v-if="sourcedata">
									<span style="margin-left: 40px;color: #000;">销售额趋势</span>
									<v-chart :height="300" :width="1200" :data="sourcedata" :scale="scale">
										<v-tooltip />
										<v-axis />
										<v-legend></v-legend>
										<!-- <v-bar position="title*sales" /> -->
										<v-stack-bar :position="'title*sales'" :color="'apps_name'"></v-stack-bar>
									</v-chart>
								</div>
							</a-tab-pane>
							<a-tab-pane tab="访问量" key="2" disabled>
								<div style="margin-top: 30px;overflow: hidden;height: 300px;" v-if="sourcedata">
									<span style="margin-left: 40px;color: #000;">访问量趋势</span>
									<v-chart :height="300" :width="1200" :data="sourcedata" :scale="linescale">
										<v-tooltip />
										<v-axis />
										<v-line position="title*sales" />
										<v-point position="title*sales" shape="circle" />

									</v-chart>
								</div>
							</a-tab-pane>
							<div slot="tabBarExtraContent" style="padding: 8px 16px 0 0;">
								<a-radio-group @change="ontimeChange" defaultValue="year" :value="timevalue">
									<a-radio-button value="day">今日</a-radio-button>
									<a-radio-button value="week">本周</a-radio-button>
									<a-radio-button value="month">本月</a-radio-button>
									<a-radio-button value="year">全年</a-radio-button>
								</a-radio-group>
								<a-range-picker :defaultValue="[moment(startdate, dateFormat), moment(enddate, dateFormat)]" @change="onChangeTime" />
							</div>
						</a-tabs>
					</div>



					<!-- <div>
						<div style="height: 300px; width: 585px;background-color: white;float: left;padding: 25px;">
							<div>
								<div style="display: inline-block;">分类销售额占比</div>
								<a-range-picker :defaultValue="[moment(startdate, dateFormat), moment(enddate, dateFormat)]" @change="onChangeTime"
								 style="float: right;margin-top: -5px;z-index: 999;" />
							</div>
							<div style="width: 500px;margin-top: -20px;" v-if="data">
								<v-chart height="300" width="200" :data="data" :padding="10">
									<v-tooltip :showTitle="false"></v-tooltip>
									<v-legend :useHtml="true" position="right-top" :reactive="true" :offset="[20, 30]" :itemMarginBottom="40"
									 :containerTpl="containerTplLegend" :itemTpl="itemTpl"></v-legend>
									<v-coord type="theta" innerRadius="0.7"></v-coord>
									<v-guide type="text" content="销售额" :top="true" :position="['40%', '45%']"></v-guide>
									<v-guide type="text" :content="sum" :top="true" :position="['39%', '55%']"></v-guide>
									<v-pie position="value" color="type" shape="sliceShape"></v-pie>
								</v-chart>
							</div>
							<div style="width: 500px;padding-top: 100px;text-align: center;" v-if="!data">
								该时间段内暂无销售信息
							</div>
						</div>
					</div> -->
				</a-layout-content>
				<bottomBar></bottomBar>
			</a-layout>
		</a-layout>
		<div>
			<a-back-top />
		</div>
	</div>
</template>

<script>
	var DataSet = require('@antv/data-set');
	import moment from 'moment';

	export default {
		data() {
			return {
				current: ['mainpage'],
				openKeys: [''],
				dateFormat: 'YYYY-MM-DD',
				startdate: this.moment().startOf('month').format("YYYY-MM-DD"),
				enddate: this.moment().endOf('month').format("YYYY-MM-DD"),
				tradeAll: null,
				tradeInfo: {
					to_be_paid: 0,
					have_paid: 0,
					delivery: 0,
					success: 0,
					finished: 0,
					refund: 0
				},
				// weekdaytitle: moment.weekdaysShort(),
				weekdaytitle: ['周一','周二','周三','周四','周五','周六','周日'],
				timevalue: 'year',
				chartMetaData: null,
				sourcedata: null,
				scale: [{
					dataKey: 'sales',
					tickInterval: 200,
				}],
				linescale: [{
					dataKey: 'sales',
					min: 0,
				}, {
					dataKey: 'title',
					min: 0,
					max: 1,
				}],
				isfinish: false,
				apps_list: [],
			}
		},
		created: function() {
			this.initialize()
		},

		methods: {
			moment,
			initialize() {
				var self = this;
				this.isfinish = false;
				this.$axios.get('/basic/getmainpagedata', {
					params: {
						startdate: this.moment().startOf('day').format(this.dateFormat) + " 00:00:00",
						enddate: this.moment().endOf('day').format(this.dateFormat) + " 23:59:59",
						apps_id: this.$store.state.now_app_state
					}
				}).then(function(res) {
					self.isfinish = true;
					self.tradeAll = res.data.tradeAll;
					for (var i = 0; i < res.data.chartMetaData.length; i++) {
						res.data.chartMetaData[i].apps_name = res.data.apps_list[res.data.chartMetaData[i].apps_id - 1].app_name
						if (res.data.chartMetaData[i].TC_Orders.length) {
							for (var j = 0; j < res.data.chartMetaData[i].TC_Orders.length; j++) {
								res.data.chartMetaData[i].receipt_price -= res.data.chartMetaData[i].TC_Orders[j].receipt_price
							}
						}
					}
					self.chartMetaData = res.data.chartMetaData;
					self.tradeInfo = res.data.tradeInfo;
					self.apps_list = res.data.apps_list;
					var newdata = self.chartyear();
					var app_temp_list = [];
					if (self.$store.state.now_app_state == 'all' || self.$store.state.now_app_state == null) {
						app_temp_list.push(1)
					} else {
						app_temp_list.push(self.$store.state.now_app_state)
					}
					for (var a = 0; a < newdata.length; a++) {
						app_temp_list.push(newdata[a].apps_id)
					}
					app_temp_list = self.packagetraverse(app_temp_list, true);
					app_temp_list = Array.from(new Set(app_temp_list));
					var sourcedata = [];
					for (var ai = 0; ai < res.data.apps_list.length; ai++) {
						if (app_temp_list.indexOf((ai + 1)) != -1) {
							for (var i = 1; i < 13; i++) {
								var temp = {};
								temp.title = i + " 月"
								temp.sales = 0;
								temp.apps_name = res.data.apps_list[ai].app_name;
								for (var j = 0; j < newdata.length; j++) {
									if (newdata[j].month == i && newdata[j].apps_id == res.data.apps_list[ai].id) {
										temp.sales = newdata[j].sum_receipt_price / 100
									}
								}
								sourcedata.push(temp);
							}
						}
					}
					self.sourcedata = sourcedata;
					var max = sourcedata[0].sales;
					for (var i = 1; i < sourcedata.length; i++) {
						if (max < sourcedata[i].sales) {
							max = sourcedata[i].sales
						};
					}
					if (max < 600) {
						max = 600;
					}
					self.scale[0].tickInterval = ((max / 6) - (max / 6) % 100);

				});
			},
			onChangeTopTime(date, dateString) {
				var starttime = dateString[0] + " 00:00:00";
				var endtime = dateString[1] + " 00:00:00";
				var self = this;

			},
			gototransactionlist(liststatus) {
				this.$router.push({
					name: 'transactionlist',
					query: {
						liststatus: liststatus
					}
				});
			},
			chartyear() {
				var self = this;
				var chartMetaData = this.chartMetaData;
				var ds = new DataSet();
				var dv = ds.createView().source(chartMetaData);
				dv.transform({
					type: 'map',
					callback(row) {
						row.year = self.moment(row.created_at).format("YYYY");
						row.month = self.moment(row.created_at).format("M");
						return row;
					}
				});
				dv.transform({
					type: 'filter',
					callback(row) { // 判断某一行是否保留，默认返回true
						return row.year == self.moment().year();
					}
				});
				dv.transform({
					type: 'aggregate', // 别名summary
					fields: ['receipt_price'], // 统计字段集
					operations: ['sum'], // 统计操作集,
					// dimension: 'apps_id',
					as: ['sum_receipt_price'], // 存储字段集
					groupBy: ['month', 'apps_name'] // 分组字段集
				})
				return dv.rows;
			},
			chartmonth() {
				var self = this;
				var chartMetaData = this.chartMetaData;
				var ds = new DataSet();
				var dv = ds.createView().source(chartMetaData);
				dv.transform({
					type: 'map',
					callback(row) {
						row.year = self.moment(row.created_at).format("YYYY");
						row.month = self.moment(row.created_at).format("M");
						row.day = self.moment(row.created_at).format("D");
						return row;
					}
				});
				dv.transform({
					type: 'filter',
					callback(row) { // 判断某一行是否保留，默认返回true
						return row.year == self.moment().year() && row.month == (self.moment()
							.month() + 1);
						// return row.year == self.moment().year();
					}
				});
				dv.transform({
					type: 'aggregate', // 别名summary
					fields: ['receipt_price'], // 统计字段集
					operations: ['sum'], // 统计操作集
					as: ['sum_receipt_price'], // 存储字段集
					groupBy: ['day', 'apps_name'] // 分组字段集
				})
				return dv.rows;
			},
			chartweek() {
				var self = this;
				var chartMetaData = this.chartMetaData;
				var ds = new DataSet();
				var dv = ds.createView().source(chartMetaData);
				dv.transform({
					type: 'map',
					callback(row) {
						row.week = self.moment(row.created_at).format("ddd");
						return row;
					}
				});
				dv.transform({
					type: 'filter',
					callback(row) { // 判断某一行是否保留，默认返回true
						return self.moment(row.created_at).isBetween(self.moment().startOf('week'), self.moment().endOf('week'));
					}
				});
				dv.transform({
					type: 'aggregate', // 别名summary
					fields: ['receipt_price'], // 统计字段集
					operations: ['sum'], // 统计操作集
					as: ['sum_receipt_price'], // 存储字段集
					groupBy: ['week', 'apps_name'] // 分组字段集
				})
				return dv.rows;
			},
			chartday() {
				var self = this;
				var chartMetaData = this.chartMetaData;
				var ds = new DataSet();
				var dv = ds.createView().source(chartMetaData);
				dv.transform({
					type: 'map',
					callback(row) {
						row.hour = self.moment(row.created_at).format("H");
						return row;
					}
				});
				dv.transform({
					type: 'filter',
					callback(row) { // 判断某一行是否保留，默认返回true
						return self.moment(row.created_at).isBetween(self.moment().startOf('day'), self.moment().endOf('day'));
					}
				});
				dv.transform({
					type: 'aggregate', // 别名summary
					fields: ['receipt_price'], // 统计字段集
					operations: ['sum'], // 统计操作集
					as: ['sum_receipt_price'], // 存储字段集
					groupBy: ['hour', 'apps_name'] // 分组字段集
				})
				return dv.rows;
			},
			chartanytime(startTime) {
				startTime[1] = startTime[1].endOf('day')
				var self = this;
				var chartMetaData = this.chartMetaData;
				var ds = new DataSet();
				var dv = ds.createView().source(chartMetaData);
				var gap = startTime[1].diff(startTime[0], 'seconds');
				var name = null;
				var isLeapYear = self.moment(startTime[0]).isLeapYear();
				// console.log(gap)
				if (gap < 86400) {
					name = 'day';
					dv.transform({
						type: 'map',
						callback(row) {
							row.date = self.moment(row.created_at);
							row.title = self.moment(row.created_at).format("H");
							return row;
						}
					});
				}

				if (gap >= 86400 && gap < 604800) {
					name = 'week';
					dv.transform({
						type: 'map',
						callback(row) {
							row.date = self.moment(row.created_at);
							row.title = self.moment(row.created_at).format("ddd");
							return row;
						}
					});
				}

				if (gap >= 604800 && gap < 2678400) {
					name = 'month';
					dv.transform({
						type: 'map',
						callback(row) {
							row.date = self.moment(row.created_at);
							row.title = self.moment(row.created_at).format("D");
							return row;
						}
					});
				}

				if (gap >= 2678400 && gap < 31536000 && !isLeapYear) {
					name = 'year';
					dv.transform({
						type: 'map',
						callback(row) {
							row.date = self.moment(row.created_at);
							row.title = self.moment(row.created_at).format("M");
							return row;
						}
					});
				}
				if (gap >= 2678400 && gap < 31622400 && isLeapYear) {
					name = 'year';
					dv.transform({
						type: 'map',
						callback(row) {
							row.date = self.moment(row.created_at);
							row.title = self.moment(row.created_at).format("M");
							return row;
						}
					});
				}

				if (gap >= 31536000 && !isLeapYear) {
					name = 'all';
					dv.transform({
						type: 'map',
						callback(row) {
							row.date = self.moment(row.created_at);
							row.title = self.moment(row.created_at).format("YYYY");
							return row;
						}
					});
				}
				if (gap >= 31622400 && isLeapYear) {
					name = 'all';
					dv.transform({
						type: 'map',
						callback(row) {
							row.date = self.moment(row.created_at);
							row.title = self.moment(row.created_at).format("YYYY");
							return row;
						}
					});
				}
				dv.transform({
					type: 'filter',
					callback(row) { // 判断某一行是否保留，默认返回true
						return row.date.isBetween(startTime[0], startTime[1]);
					}
				});
				dv.transform({
					type: 'aggregate', // 别名summary
					fields: ['receipt_price'], // 统计字段集
					operations: ['sum'], // 统计操作集
					as: ['sum_receipt_price'], // 存储字段集
					groupBy: ['title', 'apps_name'] // 分组字段集
				})
				return {
					data: dv.rows,
					name: name
				};
			},
			ontimeChange(e) {
				var self = this;
				this.timevalue = e.target.value
				if (e.target.value == 'year') {
					var newdata = self.chartyear();
					var app_temp_list = [];
					if (self.$store.state.now_app_state == 'all' || self.$store.state.now_app_state == null) {
						app_temp_list.push(1)
					} else {
						app_temp_list.push(self.$store.state.now_app_state)
					}
					for (var a = 0; a < newdata.length; a++) {
						app_temp_list.push(newdata[a].apps_id)
					}
					app_temp_list = self.packagetraverse(app_temp_list, true);
					app_temp_list = Array.from(new Set(app_temp_list));
					var sourcedata = [];
					for (var ai = 0; ai < self.apps_list.length; ai++) {
						if (app_temp_list.indexOf((ai + 1)) != -1) {
							for (var i = 1; i < 13; i++) {
								var temp = {};
								temp.title = i + " 月"
								temp.sales = 0;
								temp.apps_name = self.apps_list[ai].app_name;
								for (var j = 0; j < newdata.length; j++) {
									if (newdata[j].month == i && newdata[j].apps_id == self.apps_list[ai].id) {
										temp.sales = newdata[j].sum_receipt_price / 100
									}
								}
								sourcedata.push(temp);
							}
						}
					}
					self.sourcedata = sourcedata;
					var max = sourcedata[0].sales;
					for (var i = 1; i < sourcedata.length; i++) {
						if (max < sourcedata[i].sales) {
							max = sourcedata[i].sales
						};
					}
					if (max < 600) {
						max = 600;
					}
					self.scale[0].tickInterval = ((max / 6) - (max / 6) % 100);
				} else if (e.target.value == 'month') {
					var newdata = self.chartmonth();
					var app_temp_list = [];
					if (self.$store.state.now_app_state == 'all' || self.$store.state.now_app_state == null) {
						app_temp_list.push(1)
					} else {
						app_temp_list.push(self.$store.state.now_app_state)
					}
					for (var a = 0; a < newdata.length; a++) {
						app_temp_list.push(newdata[a].apps_id)
					}
					app_temp_list = self.packagetraverse(app_temp_list, true);
					app_temp_list = Array.from(new Set(app_temp_list));
					var sourcedata = [];
					for (var ai = 0; ai < self.apps_list.length; ai++) {
						if (app_temp_list.indexOf((ai + 1)) != -1) {
							for (var i = 1; i <= moment().endOf('month').format('D'); i++) {
								var temp = {};
								temp.title = i + "号"
								temp.sales = 0;
								temp.apps_name = self.apps_list[ai].app_name;
								for (var j = 0; j < newdata.length; j++) {
									if (newdata[j].day == i && newdata[j].apps_id == self.apps_list[ai].id) {
										temp.sales = newdata[j].sum_receipt_price / 100
									}
								}
								sourcedata.push(temp);
							}
						}
					}
					self.sourcedata = sourcedata;
					var max = sourcedata[0].sales;
					for (var i = 1; i < sourcedata.length; i++) {
						if (max < sourcedata[i].sales) {
							max = sourcedata[i].sales
						};
					}
					if (max < 600) {
						max = 600;
					}
					self.scale[0].tickInterval = ((max / 6) - (max / 6) % 100);
				} else if (e.target.value == 'week') {
					var newdata = self.chartweek();
					var app_temp_list = [];
					if (self.$store.state.now_app_state == 'all' || self.$store.state.now_app_state == null) {
						app_temp_list.push(1)
					} else {
						app_temp_list.push(self.$store.state.now_app_state)
					}
					for (var a = 0; a < newdata.length; a++) {
						app_temp_list.push(newdata[a].apps_id)
					}
					app_temp_list = self.packagetraverse(app_temp_list, true);
					app_temp_list = Array.from(new Set(app_temp_list));
					var sourcedata = [];
					var weektitle = self.weekdaytitle;
					for (var ai = 0; ai < self.apps_list.length; ai++) {
						if (app_temp_list.indexOf((ai + 1)) != -1) {
							for (var i = 1; i < 8; i++) {
								var temp = {};
								temp.title = weektitle[i - 1];
								temp.sales = 0;
								temp.apps_name = self.apps_list[ai].app_name;
								for (var j = 0; j < newdata.length; j++) {
									if (newdata[j].week == weektitle[i - 1] && newdata[j].apps_id == self.apps_list[ai].id) {
										temp.sales = newdata[j].sum_receipt_price / 100
									}
								}
								sourcedata.push(temp);
							}
						}
					}
					self.sourcedata = sourcedata;
					var max = sourcedata[0].sales;
					for (var i = 1; i < sourcedata.length; i++) {
						if (max < sourcedata[i].sales) {
							max = sourcedata[i].sales
						};
					}
					if (max < 600) {
						max = 600;
					}
					self.scale[0].tickInterval = ((max / 6) - (max / 6) % 100);
				} else if (e.target.value == 'day') {
					var newdata = self.chartday();
					var app_temp_list = [];
					if (self.$store.state.now_app_state == 'all' || self.$store.state.now_app_state == null) {
						app_temp_list.push(1)
					} else {
						app_temp_list.push(self.$store.state.now_app_state)
					}
					for (var a = 0; a < newdata.length; a++) {
						app_temp_list.push(newdata[a].apps_id)
					}
					app_temp_list = self.packagetraverse(app_temp_list, true);
					app_temp_list = Array.from(new Set(app_temp_list));
					var sourcedata = [];
					for (var ai = 0; ai < self.apps_list.length; ai++) {
						if (app_temp_list.indexOf((ai + 1)) != -1) {
							for (var i = 0; i < 24; i++) {
								var temp = {};
								temp.title = i + '点';
								temp.sales = 0;
								temp.apps_name = self.apps_list[ai].app_name;
								for (var j = 0; j < newdata.length; j++) {
									if (newdata[j].hour == i && newdata[j].apps_id == self.apps_list[ai].id) {
										temp.sales = newdata[j].sum_receipt_price / 100
									}
								}
								sourcedata.push(temp);
							}
						}
					}
					self.sourcedata = sourcedata;
					var max = sourcedata[0].sales;
					for (var i = 1; i < sourcedata.length; i++) {
						if (max < sourcedata[i].sales) {
							max = sourcedata[i].sales
						};
					}
					if (max < 600) {
						max = 600;
					}
					self.scale[0].tickInterval = ((max / 6) - (max / 6) % 100);
				}
			},
			onChangeTime(date, dateString) {
				var self = this;
				this.timevalue = null;
				var startTime = new Date(Date.parse(dateString[0].replace(/-/g, "/"))).getTime();
				var endTime = new Date(Date.parse(dateString[1].replace(/-/g, "/"))).getTime();
				var newdata = self.chartanytime(date);
				var app_temp_list = [];
				if (self.$store.state.now_app_state == 'all' || self.$store.state.now_app_state == null) {
					app_temp_list.push(1)
				} else {
					app_temp_list.push(self.$store.state.now_app_state)
				}
				for (var a = 0; a < newdata.data.length; a++) {
					app_temp_list.push(newdata.data[a].apps_id)
				}
				app_temp_list = this.packagetraverse(app_temp_list, true);
				app_temp_list = Array.from(new Set(app_temp_list));
				var name = newdata.name;
				newdata = newdata.data;
				var sourcedata = [];
				switch (name) {
					case 'day':
						for (var ai = 0; ai < self.apps_list.length; ai++) {
							if (app_temp_list.indexOf((ai + 1)) != -1) {
								for (var i = 0; i < 24; i++) {
									var temp = {};
									temp.title = i + '点';
									temp.sales = 0;
									temp.apps_name = self.apps_list[ai].app_name;
									for (var j = 0; j < newdata.length; j++) {
										if (newdata[j].title == i && newdata[j].apps_id == self.apps_list[ai].id) {
											temp.sales = newdata[j].sum_receipt_price / 100
										}
									}
									sourcedata.push(temp);
								}
							}
						}
						break;
					case 'week':
						var weektitle = self.weekdaytitle;
						for (var ai = 0; ai < self.apps_list.length; ai++) {
							if (app_temp_list.indexOf((ai + 1)) != -1) {
								for (var i = 1; i < 8; i++) {
									var temp = {};
									temp.title = weektitle[i - 1];
									temp.sales = 0;
									temp.apps_name = self.apps_list[ai].app_name;
									for (var j = 0; j < newdata.length; j++) {
										if (newdata[j].title == weektitle[i - 1] && newdata[j].apps_id == self.apps_list[ai].id) {
											temp.sales = newdata[j].sum_receipt_price / 100
										}
									}
									sourcedata.push(temp);
								}
							}
						}
						break;
					case 'month':
						for (var ai = 0; ai < self.apps_list.length; ai++) {
							if (app_temp_list.indexOf((ai + 1)) != -1) {
								for (var i = 1; i <= moment(date[0]).endOf('month').format('D'); i++) {
									var temp = {};
									temp.title = i + "号"
									temp.sales = 0;
									temp.apps_name = self.apps_list[ai].app_name;
									for (var j = 0; j < newdata.length; j++) {
										if (newdata[j].title == i && newdata[j].apps_id == self.apps_list[ai].id) {
											temp.sales = newdata[j].sum_receipt_price / 100
										}
									}
									sourcedata.push(temp);
								}
							}
						}
						break;
					case 'year':
						for (var ai = 0; ai < self.apps_list.length; ai++) {
							if (app_temp_list.indexOf((ai + 1)) != -1) {
								for (var i = 1; i < 13; i++) {
									var temp = {};
									temp.title = i + " 月"
									temp.sales = 0;
									temp.apps_name = self.apps_list[ai].app_name;
									for (var j = 0; j < newdata.length; j++) {
										if (newdata[j].title == i && newdata[j].apps_id == self.apps_list[ai].id) {
											temp.sales = newdata[j].sum_receipt_price / 100
										}
									}
									sourcedata.push(temp);
								}
							}
						}
						break;
					case 'all':
						for (var i = 0; i < newdata.length; i++) {
							var temp = {};
							temp.title = newdata[i].title
							temp.sales = newdata[i].sum_receipt_price / 100;
							temp.apps_name = newdata[i].apps_name;
							sourcedata.push(temp);
						}
						break;
					default:
						break;
				}
				self.sourcedata = sourcedata;
				var max = sourcedata[0].sales;
				for (var i = 1; i < sourcedata.length; i++) {
					if (max < sourcedata[i].sales) {
						max = sourcedata[i].sales
					};
				}
				if (max < 600) {
					max = 600;
				}
				self.scale[0].tickInterval = ((max / 6) - (max / 6) % 100);
			},
			gotopage(page) {
				this.$router.push(page);
			},
			packagesort(arr, index) {
				arr[index] += arr[index + 1];
				arr[index + 1] = arr[index] - arr[index + 1];
				arr[index] -= arr[index + 1];
			},
			packagetraverse(arr, swit) {
				for (var i = 1; i < arr.length; i++) {
					for (var k = 0; k < arr.length - 1; k++) {
						if (swit) {
							if (arr[k] > arr[k + 1]) {
								this.packagesort(arr, k);
							}
						} else {
							if (arr[k] < arr[k + 1]) {
								this.packagesort(arr, k);
							}
						}
					}
				}
				return arr;
			},
		},
	};
</script>

<style>
	.mainpage .datalist {
		/* background-color: white; */
		padding: 0 15px !important;
	}

	.mainpage .datalist>div {
		/* height: 200px; */
		background-color: white;
		height: 170px;
		padding: 16px;
	}

	.mainpage .datalist>div .title {
		font-size: 14px;
		color: #999;
	}

	.mainpage .orderlist {
		background-color: white;
		height: 130px;
		text-align: center;
		cursor: pointer;
	}

	.mainpage .orderlist:hover {
		background-color: #0099FF;
	}

	.mainpage .orderlist .hovernum {
		color: #0099FF;
	}

	.mainpage .orderlist:hover .hovernum {
		color: white;
	}

	.mainpage .orderlist:hover .hovertitle {
		color: white;
	}
</style>



// WEBPACK FOOTER //
// index.vue?11cb63ba